import { AccentFoldService, AddOnTypes, AppService, ColorPickerService, CommonCloudstudioService, CommonMapService, CoreProxyService, CoreTypes, IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, LabelValue } from 'common-cloudstudio';
import { Subscription, Observable } from 'rxjs';
import { GearTypes, GearAppService } from 'common-gear';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MapService } from 'src/app/shared/services/map.service';
import { Router } from "@angular/router";
import { SharedService } from 'src/app/shared/services/shared.service';
import { GoogleMap } from '@angular/google-maps';
declare let MarkerClusterer: any;
declare let environment: any;

interface Metadata {
  id: any;
  deviceDescription: string;
  deviceDisplayText: string;
}

interface IconMarker {
  latitude: number;
  longitude: number;
  url: string | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol;
  html?: string;
  metadata: Metadata;
}

@Component({
  selector: 'app-alarms-map',
  templateUrl: './alarms-map.component.html',
  styleUrls: ['./alarms-map.component.scss']
})

export class AlarmsMapComponent implements OnInit, OnDestroy {
  @ViewChild('deviceModal') public _deviceModal: any;
  @ViewChild(GoogleMap) googleMap: GoogleMap;
  bounds: any;
  _lastOpenInfoWindow: any;
  _longitudeCenter: number = -105.012516;
  _latitudeCenter: number = 10.875404;
  _zoom: number = 4;
  _mapWidth: string;
  map: google.maps.Map;
  mapDefinition: CoreTypes.MapDefinition;
  enableHeatmap: boolean = false;
  heatmap: google.maps.visualization.HeatmapLayer | null = null;
  heatmapData: (google.maps.LatLng | google.maps.visualization.WeightedLocation)[] = [];
  heatmapLayers: google.maps.visualization.HeatmapLayer[] = []; // Para múltiples heatmaps
  markers: google.maps.Marker[] = [];
  markerClusterer: any;
  infoWindows: google.maps.InfoWindow[] = [];
  readonly mcOptions = {
    styles: [{
      height: 24,
      url: 'assets/icons/default.png',
      width: 24
    }],
    ignoreHiddenMarkers: true,
    maxZoom: 15,
    minimumClusterSize: 2,
    gridSize: 60
  };
  clustersFullList: {
    alarmData: CoreTypes.AlarmWithHeatMap;
    markerData: IconMarker;
  }[] = [];
  clustersFilteredList: {
    alarmData: CoreTypes.AlarmWithHeatMap;
    markerData: IconMarker;
  }[] = [];
  _activeMarker: number;

  _dataPacketSub: Subscription;
  subscriptions: Subscription[] = [];

  _alamrsModalTextAttributes: CoreTypes.TextAttributeList[];
  _successMessage: string;
  _errorMessage: string;

  _deviceID : number;
  devicesOpts : Array<IMultiSelectOption>  = [];
  devicesList : number[] = [];
  devices: number[] = [];
  devicesIDs: number[] = [];

  devicesFullList : CoreTypes.Device[];

  executionNumber: number = 0;
  searchText: string = '';
  clientID: number;
  facilityID: number;
  firstExecution: boolean = true;
  activeTab = 0;
  facilityData: GearTypes.GearMapFacility = new GearTypes.GearMapFacility();
  facilitiesIds: number[] = [];
  facilitiesList: Array<IMultiSelectOption> = [];
  _facilityID: number;
  status: number = 0;
  _facilityType: LabelValue<number>;
  _facilityTypesList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    
  };
  _multiSelectTexts: IMultiSelectTexts = {
    checkAll: this._appService.CoreCommonLiterals.MultiSelect_All_Male, // 'Select all'
    uncheckAll: this._appService.CoreCommonLiterals.None_Male, // 'Unselect all'
    checked: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male, // 'item selected'
    checkedPlural: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male,
    searchPlaceholder: this._appService.CoreCommonLiterals.MultiSelect_Find, //'Find'
    defaultTitle: this._appService.CoreCommonLiterals.Select, // 'Select'
    allSelected: this._appService.CoreCommonLiterals.MultiSelect_All_Male // 'All selected'
  };
  
  facilities: number[] = [];
  debounceAction: any;

  private _destroyed = false;
  private _sequenceNumber = 0;
  private timer: any;
  private indexTable: Array<number> = [];
  private _lastProcessedData: string = ''; 
  private _currentGradientColor: string = ''; 
  private _currentRadius: number = 30; 
  
  private generateDataHash(): string {
    return this.clustersFilteredList.map(cluster => 
      `${cluster.alarmData.AlarmID}-${cluster.markerData.latitude}-${cluster.markerData.longitude}`
    ).join('|');
  }
  
  private getPredominantColor(): string {
    const colorCount = new Map<string, number>();
    
    this.clustersFullList.forEach((item) => {
      if (item.alarmData && item.alarmData.PointColor) {
        const color = this.colorService.rgbToHexa(item.alarmData.PointColor);
        colorCount.set(color, (colorCount.get(color) || 0) + 1);
      }
    });
    
    if (colorCount.size === 0) return '#FF0000';
    
    let predominantColor = '#FF0000';
    let maxCount = 0;
    
    colorCount.forEach((count, color) => {
      if (count > maxCount) {
        maxCount = count;
        predominantColor = color;
      }
    });
    
    return predominantColor;
  }
  
  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  addOnMapping:GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  maxPanelWidth: number = 700;

  initialPanelWidth: number = 380;
  _paramSelected: CoreTypes.FormParameter = new CoreTypes.FormParameter();
  enableFilter: boolean = true;
  formParameterList: CoreTypes.FormParameter[] = [];
  formParameterApplied: CoreTypes.FormParameter[] = [];
  visualizationType: LabelValue<number> = new LabelValue<number>();
  visualizationTypeList: LabelValue<number>[] = [];
  initialLatitude: number;
  initialLongitude: number;
  initialZoom: number;
  mapApiReady = false;
  googleMapOptions: any;

  constructor(
    public _mapService: MapService,
    public commonMapService: CommonMapService,
    public _appService: AppService,
    private _router: Router,
    public _gearService: GearAppService,
    private _accentFoldService: AccentFoldService,
    private sharedService: SharedService,
    private _coreProxyService: CoreProxyService,
    private colorService: ColorPickerService,
  ) {}

  async ngOnInit() {
    this.resetComponentState();
    
    try {
      let map = await this._mapService.load();
      if(map) {
        this.mapApiReady = true;
        this.onMapReady(map);
      }
    } catch (error) {}

    this.maxPanelWidth = window.innerWidth*0.7 - 260;
    this._facilityID = this._appService.getFacilityID();
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this.status = 0;
      this._facilityID = this._appService.getFacilityID();
      this.getFacilities();
      this.getMapDefinition();
    }))
    this.getFacilities();
    this.getMapDefinition();
  }
  
  ngOnDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.debounceAction);
    this._destroyed = true;
    this.debounceAction = null;
    this._dataPacketSub?.unsubscribe();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  initData() {
    clearTimeout(this.timer);
    this._sequenceNumber = 0;
    this.status = 0;
    this.firstExecution = true;
    this._lastProcessedData = ''; 
    this.indexTable = [];
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.searchText = '';
    this.clearAllMarkers();
    if (this.facilitiesIds.length === 0 && this._facilityID) {
      this.facilitiesIds = [this._facilityID];
      this.facilities = [this._facilityID];
    }
    
    this.getRecursively();
  }

  getRecursively() {
    this.addOnMapping = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);
    if(this._destroyed || (!this.addOnMapping?.Enabled &&(this.addOnMapping?.Visibility === this.addOnFeatureVisibility.ShowStar || this.addOnMapping?.Visibility === this.addOnFeatureVisibility.Visible))) { return;}
    
    if (!this._facilityID || this.facilitiesIds.length === 0) {
      this.timer = setTimeout(() => this.getRecursively(), 1000);
      return;
    }
    
    if (!this.map || typeof this.map.setCenter !== 'function') {
      this.timer = setTimeout(() => this.getRecursively(), 500);
      return;
    }
    
    if(this._dataPacketSub) { this._dataPacketSub.unsubscribe(); }
    this._dataPacketSub = this.getDataPackages().subscribe(data => {
      this.status = 1;
      this.getRecursively();
    }, (interval) => {
      this.timer = setTimeout(()=> this.getRecursively(), interval);
    })
  }

  getFacilities() {
    if( !this._appService.getClientID()){ return; }
    this.facilitiesList = [];
    this.facilitiesIds = [];
    this.facilities = [];
    if (this._facilityID) {
      this.facilitiesIds.push(this._facilityID);
      this.facilities.push(this._facilityID);
    }
    
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this._coreProxyService.FacilityService.EnumFacilities(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      res => {
        res.forEach(x => {
          let item = {
            name: x.Description,
            id: x.FacilityID
          }
          optionsList.push(item);
          
          // Evitar duplicados
          if (!this.facilitiesIds.includes(x.FacilityID)) {
            this.facilitiesIds.push(x.FacilityID);
            this.facilities.push(x.FacilityID);
          }
        });
        this.facilitiesList = optionsList;
      }, 
      e => {
        this._appService.showException(e);
      }
    );
  }

  getMapDefinition(): void {
    this._coreProxyService.AlarmService.GetAlarmWithHeatMapDefinition(
      this._appService.getAccessToken(),
      this._facilityID,
      this.formParameterApplied,
      (res: CoreTypes.MapDefinition) => {
        this.mapDefinition = res;
        this.setDefaultVisualizationType();
      },
      (err: any) => {
        this._appService.showException(err);
      }
    );
  }

  setDefaultVisualizationType() {
    this.visualizationTypeList = this.mapDefinition.LayerType.map(layerType => {
      let label = '';
      switch (layerType) {
        case CoreTypes.MapLayerType.Roadmap:
          label = 'General';
          break;
        case CoreTypes.MapLayerType.Heatmap:
          label = 'Heat map';
          break;
          case CoreTypes.MapLayerType.Satellite:
            label = 'Satellite';
            break;
        default:
          label = 'General';
      }
      return { label: label, value: layerType };
    });
    this.visualizationType = this.visualizationTypeList[0];
    this.enableHeatmap = this.visualizationType.value === CoreTypes.MapLayerType.Heatmap;
    if(this.enableHeatmap) {
      setTimeout(() => {
        this.generateHeatmapData();
        this.createHeatmapButtons();
      }, 500);
    }
  }

  getDataPackages(): Observable<number> {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    return new Observable(observer => {

      let facilitiesToUse = [...this.facilitiesIds];
      if (facilitiesToUse.length === 0 && this._facilityID) {
        facilitiesToUse = [this._facilityID];
      }
      
      if(!this._appService.onMapIconDetails.value || facilitiesToUse.length === 0) {
        setTimeout(() => {
          observer.next(); 
        }, 1000);
        return; 
      }
      
      this._coreProxyService.AlarmService.GetAlarmWithHeatMapDataPacket(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._facilityID,
        facilitiesToUse,
        this._sequenceNumber,
        500,
        this.formParameterApplied,
        success => {
          this.status = 1;
          if(executionNumber !== this.executionNumber) {
            this.firstExecution = false;
            observer.next();
            return;
          }
          try {
            if (this._sequenceNumber > success.HighestSequenceNumber) {
              return observer.next();
            }

            this._sequenceNumber = success.HighestSequenceNumber;

            if (this.firstExecution) {
              var sw = new google.maps.LatLng(success.InitialViewSW.Latitude, success.InitialViewSW.Longitude);
              var ne = new google.maps.LatLng(success.InitialViewNE.Latitude, success.InitialViewNE.Longitude);
              this.bounds = new google.maps.LatLngBounds(sw, ne);
                          
              this.initialLatitude = (sw.lat() + ne.lat()) / 2;
              this.initialLongitude = (sw.lng() + ne.lng()) / 2;
              this.initialZoom = 12;
            
              this.centerMapInitially();
            }

            const sites = success.Points;
            let refreshed = [];

            for (let index = 0; index < sites.length; index++) {
              refreshed.push(sites[index].AlarmID);
              this.addMarker(sites[index]);
            }

            this.updateMarkersEfficient();

            if (this.firstExecution) {
              this.map.fitBounds(this.bounds);
              
              // Aplicar tipo de visualización
              setTimeout(() => {
                this.onVisualizationTypeChange(null);
              }, 200);
            }
            this.firstExecution = false;
            observer.next();
          } catch (error) {
            observer.error(5000);
          }
        },
        err => {
          this.status = 2;
          this._appService.showException(err);
          observer.error(15000);
        }
      );
    });
  }

  addMarker(item: CoreTypes.AlarmWithHeatMap) {
    if (!item.LocationAddress?.Location) { return; } 
    let index = this.indexTable.indexOf(item.AlarmID);
    let color = this.colorService.rgbToHexa((item.PointColor));

    let findCustomIcon = this._appService.onMapIconDetails.value.DevicesMapIcons.find(x => x.MapIconID === item.IconID);
    var image = {
      url: findCustomIcon ? findCustomIcon.Default : "assets/icons/default.png",
      size: new google.maps.Size(40, 40),
      scaledSize: !item.IconID || item.IconID === 0 ? new google.maps.Size(25, 40) : new google.maps.Size(32, 32)
    };
    
    var markert: google.maps.Marker = new google.maps.Marker({
      icon: findCustomIcon ? image : this.pin(color, false),
    });

    if (index > -1) {
      // Verificar si los datos han cambiado antes de actualizar
      const existingCluster = this.clustersFullList[index];
      const hasChanged = 
        existingCluster.alarmData.Description !== item.Description ||
        existingCluster.alarmData.DisplayText !== item.DisplayText ||
        existingCluster.markerData.latitude !== item.LocationAddress.Location.Latitude ||
        existingCluster.markerData.longitude !== item.LocationAddress.Location.Longitude;
      
      if (hasChanged) {
        this.clustersFullList[index].alarmData = item;
        this.clustersFullList[index].markerData.url = markert.getIcon();
        this.clustersFullList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
        this.clustersFullList[index].markerData.longitude = item.LocationAddress.Location.Longitude;

        if(this.clustersFilteredList[index]) {
          this.clustersFilteredList[index].alarmData = item;
          this.clustersFilteredList[index].markerData.url = markert.getIcon();
          this.clustersFilteredList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
          this.clustersFilteredList[index].markerData.longitude = item.LocationAddress.Location.Longitude;
        }
      }
    } else {
      const cluster = {
        alarmData: item,
        markerData: {
          latitude: item.LocationAddress.Location.Latitude,
          longitude: item.LocationAddress.Location.Longitude,
          url: markert.getIcon(),
          metadata: { id: item.AlarmID, deviceDescription: item.Description, deviceDisplayText: item.DisplayText },
          html: `
            <div class="marker-tooltip">
              <div class="tooltip-header">
                <span class="tooltip-title text-primary">
                  <i class="fa-solid fa-server mr-1"></i> ${item.Description}
                </span>
                <span class="tooltip-close mb-1" onclick="window.dispatchEvent(new CustomEvent('close-info-window', { detail: ${item.AlarmID} }))">✖</span>
              </div>
              <div class="tooltip-body mt-1">
                <span class="tooltip-description">
                  <i class="fa-solid fa-triangle-exclamation mr-1 text-warning"></i> ${item.DisplayText}
                </span>
              </div>
            </div>
          `
        }
      };

      this.indexTable.push(item.AlarmID);
      this.clustersFullList.push(cluster);
      this.clustersFilteredList.push(cluster);
      this.facilityData = {
        Description: item.Description,
        FacilityID: item.FacilityID,
        ShowGroupedAlarmsOnMaps: item.ShowGrouped,
        IconID: item.IconID,
        Location: item.LocationAddress.Location,
        Stats: null
      }

      if (this.firstExecution) {
        this.bounds.extend(new google.maps.LatLng(item.LocationAddress.Location.Latitude, item.LocationAddress.Location.Longitude));
      }
    }
  }
  
  pin(color, circle?:boolean) {
    let path;
    circle ? path = "M-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" : path = 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0';
    return {
      path :path,
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#fff',
      strokeWeight: circle ? .1 : 2,
      scale: 1,
    };
  }

  private createMarkerTooltipContent(cluster: any): string {
    return cluster.markerData.html || `
      <div class="marker-tooltip">
        <div class="tooltip-header">
          <span class="tooltip-title text-primary">
            <i class="fa-solid fa-server mr-1"></i> ${cluster.alarmData.Description}
          </span>
        </div>
        <div class="tooltip-body mt-1">
          <span class="tooltip-description">
            <i class="fa-solid fa-triangle-exclamation mr-1 text-warning"></i> ${cluster.alarmData.DisplayText}
          </span>
        </div>
      </div>
    `;
  }

  private createMarker(cluster: any): google.maps.Marker {
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(cluster.markerData.latitude, cluster.markerData.longitude),
      map: this.map,
      icon: cluster.markerData.url,
      title: cluster.alarmData.Description,
      optimized: true
    });

    const infoWindow = new google.maps.InfoWindow({
      content: this.createMarkerTooltipContent(cluster),
      maxWidth: 300,
      pixelOffset: new google.maps.Size(0, -20)
    });

    this.infoWindows.push(infoWindow);

    marker.addListener('mouseover', () => {
      this._activeMarker = cluster.alarmData.AlarmID;
      infoWindow.open(this.map, marker);
    });

    marker.addListener('mouseout', () => {
      this._activeMarker = 0;
      infoWindow.close();
    });

    marker.addListener('click', () => this.onMarkerClick(cluster.markerData));

    return marker;
  }

  private updateMarkerClusterer(): void {
    if (this.markerClusterer) {
      this.markerClusterer.clearMarkers();
      this.markerClusterer.addMarkers(this.markers);
    }
  }

  private clearMarkers(): void {
    if (this.markers.length > 0) {
      this.markers.forEach(marker => {
        marker.setMap(null);
        google.maps.event.clearInstanceListeners(marker);
      });
      this.markers = [];
    }

    if (this.infoWindows.length > 0) {
      this.infoWindows.forEach(infoWindow => {
        infoWindow.close();
      });
      this.infoWindows = [];
    }
  }

  updateMarkers() {
    if (!this.map || typeof this.map.setCenter !== 'function') {
      return;
    }
    
    const currentDataHash = this.generateDataHash();
    if (currentDataHash === this._lastProcessedData && this.markers.length > 0) {
      return;
    }
    
    this._lastProcessedData = currentDataHash;
    this.clearMarkers();

    this.markers = this.clustersFilteredList.map((cluster, index) => 
      this.createMarker(cluster)
    );
    
    this.updateMarkerClusterer();
  }

  updateMarkersEfficient() {
    if (!this.map || typeof this.map.setCenter !== 'function') {
      return;
    }
    
    const currentDataHash = this.generateDataHash();
    if (currentDataHash === this._lastProcessedData && this.markers.length > 0) {
      return;
    }
    
    this._lastProcessedData = currentDataHash;
    
    if (this.infoWindows.length > this.clustersFilteredList.length) {
      const infoWindowsToRemove = this.infoWindows.splice(this.clustersFilteredList.length);
      infoWindowsToRemove.forEach(infoWindow => {
        infoWindow.close();
      });
    }
    
    this.clustersFilteredList.forEach((cluster, index) => {
      const existingMarker = this.markers[index];
      
      if (existingMarker) {
        existingMarker.setPosition(new google.maps.LatLng(cluster.markerData.latitude, cluster.markerData.longitude));
        existingMarker.setIcon(cluster.markerData.url);
        existingMarker.setTitle(cluster.alarmData.Description);
        
        if (this.infoWindows[index]) {
          this.infoWindows[index].setContent(this.createMarkerTooltipContent(cluster));
        }
      } else {
        this.markers.push(this.createMarker(cluster));
      }
    });
    
    if (this.markers.length > this.clustersFilteredList.length) {
      const markersToRemove = this.markers.splice(this.clustersFilteredList.length);
      markersToRemove.forEach(marker => {
        marker.setMap(null);
        google.maps.event.clearInstanceListeners(marker);
      });
    }
    
    this.updateMarkerClusterer();
  }

  onMapReady($event) {
    if(environment && environment.useOfflineMode) {
      return;
    }
    
    if ($event && $event.maps) {
      const mapKeys = Object.keys($event.maps);
      for (const key of mapKeys) {
        const mapObj = $event.maps[key];
        if (mapObj && typeof mapObj.setCenter === 'function' && typeof mapObj.setZoom === 'function') {
          this.map = mapObj;
          break;
        }
      }
    }
    
    if (!this.map) {
      if ($event && typeof $event.setCenter === 'function' && typeof $event.setZoom === 'function') {
        this.map = $event;
      } else if ($event && $event.googleMap && typeof $event.googleMap.setCenter === 'function') {
        this.map = $event.googleMap;
      } else if ($event && $event.map && typeof $event.map.setCenter === 'function') {
        this.map = $event.map;
      }
    }
    
    if (!this.map) {
      setTimeout(() => {
        this.tryGetMapFromViewChild();
      }, 2000);
    }
    
    this.googleMapOptions = {
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_LEFT
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    if(this._appService.getClientID()) {
      this.clientID = this._appService.getClientID();
      
      setTimeout(() => {
        this.centerMapInitially();
      }, 500);
      
      if (this.firstExecution) {
        this.initData();
      }
    }

    if (typeof MarkerClusterer !== 'undefined') {
      this.markerClusterer = new MarkerClusterer(this.map, [], this.mcOptions);
    }

    this.subscriptions.push(this._appService.onFacilitySet.subscribe(_ => {
      const clientID = this._appService.getClientID();
      if (this.clientID === clientID) { return; }
      this.clientID = clientID;
      this.initData();
    }));
  }

    centerMapInitially() {
    if (!this.map) return;
  
    if (this.initialLatitude && this.initialLongitude) {
      this.map.setCenter(new google.maps.LatLng(this.initialLatitude, this.initialLongitude));
      if (this.initialZoom) {
        this.map.setZoom(this.initialZoom);
      }
    } else if (this.bounds) {
      this.map.fitBounds(this.bounds);
    }
  }

  tryGetMapFromViewChild() {
    if (this.googleMap && this.googleMap.googleMap && typeof this.googleMap.googleMap.setCenter === 'function') {
      this.map = this.googleMap.googleMap;
      if (!this.markerClusterer && typeof MarkerClusterer !== 'undefined') {
        this.markerClusterer = new MarkerClusterer(this.map, [], this.mcOptions);
      }
      
      // Centrar el mapa siempre que se obtenga desde ViewChild
      setTimeout(() => {
        this.centerMapInitially();
      }, 100);
    }
  }

  createHeatmapButtons() {
    const buttonsConfig = [
      { id: 'toggle-heatmap', text: 'Toggle Heatmap', action: () => this.toggleHeatmap() },
      { id: 'change-gradient', text: 'Change Gradient', action: () => this.changeGradient() },
      { id: 'change-radius', text: `Change Radius`, action: () => this.changeRadius() }
    ];

    const existingButtons = document.querySelectorAll('#toggle-heatmap, #change-gradient, #change-radius');
    existingButtons.forEach(button => button.remove());
    const buttonContainer = document.createElement('div');
    buttonContainer.id = 'heatmap-controls';
    buttonsConfig.forEach(config => {
      const button = document.createElement('button');
      button.id = config.id;
      button.innerText = config.text;
      button.addEventListener("click", config.action);
      buttonContainer.appendChild(button);
    });

    const mapDiv = this.googleMap.googleMap?.getDiv();
    if (mapDiv) {
      mapDiv.appendChild(buttonContainer);
    }
    
    this.updateToggleButtonState();
  }

  generateHeatmapData(list?: any) {
    this.heatmapData = [];
    let heatmapData = list ? list : this.clustersFullList;
    this.createMultiColorHeatmaps(heatmapData);
  }

  private createMultiColorHeatmaps(heatmapData: any[]) {
    this.heatmapLayers.forEach(layer => {
      if (layer) {
        layer.setMap(null);
      }
    });
    this.heatmapLayers = [];
    
    if (this.heatmap) {
      this.heatmap.setMap(null);
      this.heatmap = null;
    }
    
    // Agrupar datos por color
    const colorGroups = new Map<string, any[]>();
    
    heatmapData.forEach((item) => {
      if (item.alarmData && item.alarmData.LocationAddress.Location) {
        const color = item.alarmData.PointColor ? 
          this.colorService.rgbToHexa(item.alarmData.PointColor) : '#FF0000';
        
        if (!colorGroups.has(color)) {
          colorGroups.set(color, []);
        }
        colorGroups.get(color).push(item);
      }
    });
    
    // Crear un heatmap por cada color
    colorGroups.forEach((items, color) => {
      const heatmapDataForColor: (google.maps.LatLng | google.maps.visualization.WeightedLocation)[] = [];
      
      items.forEach((item) => {
        const latLng = new google.maps.LatLng(
          item.alarmData.LocationAddress.Location.Latitude, 
          item.alarmData.LocationAddress.Location.Longitude
        );
        
        let weight = 1;
        if (item.alarmData.LocationAddress.Weight !== null && 
            item.alarmData.LocationAddress.Weight !== undefined) {
          weight = Math.max(0.1, Math.min(100, item.alarmData.LocationAddress.Weight));
        }
        
        const weightedLocation: google.maps.visualization.WeightedLocation = {
          location: latLng,
          weight: weight
        };
        heatmapDataForColor.push(weightedLocation);
      });
      
      // Crear gradiente para este color
      const gradient = this.createHighContrastGradient(color);
      
      // Crear heatmap para este color
      const heatmapLayer = new google.maps.visualization.HeatmapLayer({
        data: heatmapDataForColor,
        map: this.googleMap.googleMap,
        gradient: gradient,
        radius: this._currentRadius,
        opacity: 0.9
      });
      
      this.heatmapLayers.push(heatmapLayer);
      if (!this.heatmap) {
        this.heatmap = heatmapLayer;
        this._currentGradientColor = color;
      }
    });
  }

  onMarkerClick(marker: IconMarker) {
    this._appService.startLoading();
    this._deviceModal.open();
    this._appService.stopLoading();
    this._alamrsModalTextAttributes = [];
    
    this._alamrsModalTextAttributes.push({
      Description: marker.metadata.deviceDescription,
      TextAttributes: [{Name: marker.metadata.deviceDisplayText, Value: null, IconType: 2, Description: marker.metadata.deviceDisplayText}]
    });
   /*  this._coreProxyService.DeviceService.GetDeviceMapDetails(
      this._appService.getAccessToken(),
      marker.metadata.id,
      (details: CoreTypes.DeviceMapDetails) => {
        this._appService.stopLoading();
        this._deviceModalTextAttributes = details.TextAttributes;
        this._deviceModalId = details.DeviceID;
        this._deviceModal.open();
      }, err => {
        this._appService.showException(err);
    }); */
  }

  onFacilityModalClose() {
    this._alamrsModalTextAttributes = [];
  }

  onCenterChange($event) {}

  boundsChange($event) {}

  onZoomChange($event) {}

  search(e: any) {
    let value: string = this._accentFoldService.accentFold(e.target.value.toLowerCase());
    if(value.length > 0) {
      this.clustersFilteredList = [];

      this.clustersFullList.forEach((item) => {
        let displayText = this._accentFoldService.accentFold(item.alarmData.DisplayText.toLowerCase());
        let description = this._accentFoldService.accentFold(item.alarmData.Description.toLowerCase());
        // Agregar búsqueda por ID de alarma (similar a device-map)
        if(displayText.indexOf(value) > -1 || description.indexOf(value) > -1 || item.alarmData.AlarmID == parseInt(value)) {
          this.clustersFilteredList.push(item);
        }
      });
    } else {
      this.clustersFilteredList = this.clustersFullList;
    }
    
    // Actualizar markers después de filtrar
    if (!this.enableHeatmap) {
      this.updateMarkersEfficient();
    }
  }

  goToWithDevice(facility, device: CoreTypes.DeviceMap, route: string) {
    this.sharedService.goToWithFacilityOrDevice(facility, route, device);
  }

  openCameraModal(link: string) {
    return this._router.navigate(['/', {outlets: {modal: ['camera', btoa(link)]}}]);
  }

  applyFilters(controlName:string) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      let find = [];
      let sites = [];
      this.clustersFilteredList = [];
      if(controlName === 'facilities'){
        find = this.clustersFullList.filter(item => this.facilitiesIds.includes(item.alarmData.FacilityID));
      
        if(find.length > 0 && this.facilitiesIds.length > 0) {
          for(let i = 0; i < find.length; i++) {
            let alarm = find[i];
            sites.push(alarm);
            if(!this.enableHeatmap) {
              this.clustersFilteredList.push(alarm);
            } else {
              this.generateHeatmapData(sites);
            }
          }
          
          // Actualizar markers una sola vez después de procesar todos los filtros
          if (!this.enableHeatmap) {
            this.updateMarkersEfficient();
          }
        }
      }
    }, 300);
  }

  emitChangeParam(event: any) {
    console.log(event, "event");
  }

  toggleHeatmap() {
    if (this.enableHeatmap && this.heatmapLayers.length > 0) {
      const hasVisibleHeatmap = this.heatmapLayers.some(layer => layer && layer.getMap() !== null);
      
      if (hasVisibleHeatmap) {
        this.heatmapLayers.forEach(layer => {
          if (layer) {
            layer.setMap(null);
          }
        });
        this.heatmap = null;
      } else {
        this.heatmapLayers.forEach(layer => {
          if (layer) {
            layer.setMap(this.googleMap.googleMap);
          }
        });
        if (this.heatmapLayers.length > 0) {
          this.heatmap = this.heatmapLayers[0];
        }
      }
      
      this.updateToggleButtonState();
    } else {
      if (this.visualizationType.value === CoreTypes.MapLayerType.Heatmap) {
        this.generateHeatmapData();
        this.updateToggleButtonState();
      }
    }
  }

  changeGradient(): void {
    if (!this.heatmap) return;
    
    // Definir una paleta de colores alternativos para el gradiente
    const alternativeColors = [
      '#FF0000', // Rojo
      '#00FF00', // Verde
      '#0000FF', // Azul
      '#FFFF00', // Amarillo
      '#FF00FF', // Magenta
      '#800080', // Púrpura
      '#FF4500', // Naranja rojizo
    ];
    
    let currentColor = this._currentGradientColor || this.getPredominantColor();
    let nextColor = alternativeColors[0]; 
    const currentIndex = alternativeColors.findIndex(color => color.toLowerCase() === currentColor.toLowerCase());
    if (currentIndex !== -1) {
      nextColor = alternativeColors[(currentIndex + 1) % alternativeColors.length];
    }
    
    const newGradient = [
      `rgba(0, 0, 0, 0)`,                    
      `${nextColor}70`,                       
      `${nextColor}90`,                       
      `${nextColor}B0`,                       
      `${nextColor}D0`,                       
      `${nextColor}E0`,                       
      `${nextColor}FF`                        
    ];
  
    // Aplicar el nuevo gradiente y actualizar el color actual
    this.heatmap.set("gradient", newGradient);
    this._currentGradientColor = nextColor;
  }

  changeRadius(): void {
    if (!this.enableHeatmap || this.heatmapLayers.length === 0) return;
    
    // Definir diferentes tamaños de radio para alternar
    const radiusOptions = [40, 60, 80];
    
    // Encontrar el radio actual en las opciones
    let currentIndex = radiusOptions.findIndex(radius => radius === this._currentRadius);
    if (currentIndex === -1) {
      currentIndex = 0; // Si no se encuentra, empezar desde el primero
    }
    
    const nextIndex = (currentIndex + 1) % radiusOptions.length;
    const newRadius = radiusOptions[nextIndex];
    
    this.heatmapLayers.forEach(layer => {
      if (layer) {
        layer.set("radius", newRadius);
      }
    });
    
    this._currentRadius = newRadius;
  }
  
  private createHighContrastGradient(baseColor: string): string[] {
    return [
      `rgba(0, 0, 0, 0)`,                    
      `${baseColor}70`,                       // Bajo (más visible)
      `${baseColor}90`,                       // Medio-bajo
      `${baseColor}B0`,                       // Medio
      `${baseColor}D0`,                       // Medio-alto
      `${baseColor}E0`,                       // Alto
      `${baseColor}FF`                        // Máximo
    ];
  }
  
  updateToggleButtonState() {
    const toggleButton = document.getElementById('toggle-heatmap') as HTMLButtonElement;
    const radiusButton = document.getElementById('change-radius') as HTMLButtonElement;
    
    if (toggleButton) {
      const hasVisibleHeatmap = this.heatmapLayers.some(layer => layer && layer.getMap() !== null);
      if (this.enableHeatmap && hasVisibleHeatmap) {
        toggleButton.innerText = 'Hide Heatmap';
      } else {
        toggleButton.innerText = 'Show Heatmap';
      }
    }
  }

  private clearAllMarkers() {
    this.clearMarkers();
    
    // Limpiar heatmaps
    this.heatmapLayers.forEach(layer => {
      if (layer) {
        layer.setMap(null);
      }
    });
    this.heatmapLayers = [];
    
    if (this.heatmap) {
      this.heatmap.setMap(null);
      this.heatmap = null;
    }
    
    if (this.markerClusterer) {
      this.markerClusterer.clearMarkers();
    }
    
    this.bounds = null;
  }

  private resetComponentState() {
    clearTimeout(this.timer);
    clearTimeout(this.debounceAction);
    
    if (this._dataPacketSub) {
      this._dataPacketSub.unsubscribe();
      this._dataPacketSub = null;
    }
    
    this._sequenceNumber = 0;
    this.status = 0;
    this.firstExecution = true;
    this._lastProcessedData = '';
    this._currentGradientColor = '';
    this._currentRadius = 30;
    this.indexTable = [];
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.heatmapData = [];
    this.searchText = '';
    this.clearAllMarkers();
    this.bounds = null;
    this.initialLatitude = null;
    this.initialLongitude = null;
    this.initialZoom = null;
    this.enableHeatmap = false;
    this.visualizationType = new LabelValue<number>();
    this.visualizationTypeList = [];
  }
  
  onVisualizationTypeChange(event: any) {
    if (this.map && typeof this.map.setMapTypeId === 'function') {
      try {
        switch (this.visualizationType.value) {
          case CoreTypes.MapLayerType.Roadmap:
            this.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
            break;
          case CoreTypes.MapLayerType.Satellite:
            this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
            break;
          case CoreTypes.MapLayerType.Hybrid:
            this.map.setMapTypeId(google.maps.MapTypeId.HYBRID);
            break;
          case CoreTypes.MapLayerType.Terrain:
            this.map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
            break;
          default:
            this.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
        }

      } catch (error) {
        setTimeout(() => {
          this.onVisualizationTypeChange(event);
        }, 500);
        return;
      }
    } else {
      setTimeout(() => {
        this.onVisualizationTypeChange(event);
      }, 1000);
      return;
    }
    
    this.enableHeatmap = this.visualizationType.value === CoreTypes.MapLayerType.Heatmap;
    this._lastProcessedData = '';
    
    const heatmapControls = document.getElementById('heatmap-controls');
    if (heatmapControls) {
      heatmapControls.style.display = this.enableHeatmap ? 'flex' : 'none';
    }
    
    if (this.enableHeatmap) {
      this.clustersFilteredList = []; 
      this.markers.forEach(marker => {marker.setMap(null);});
      this.markers = [];
      if (!document.getElementById('toggle-heatmap')) {
        this.createHeatmapButtons();
      }
      setTimeout(() => {
        this.generateHeatmapData();
        this.updateToggleButtonState();
      }, 100);
    } else {
      this.clustersFilteredList = this.clustersFullList;
      this.heatmapLayers.forEach(layer => {
        if (layer) {
          layer.setMap(null);
        }
      });
      this.heatmapLayers = [];
      if (this.heatmap) {
        this.heatmap.setMap(null);
        this.heatmap = null;
      }
      if (this.map && typeof this.map.setCenter === 'function') {
        this.updateMarkersEfficient();
      } else {
        setTimeout(() => {
          this.updateMarkersEfficient();
          this.updateToggleButtonState();
        }, 100);
      }
    }
  }

}